import { createRoot } from 'react-dom/client';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ToasterWrapper from '@/react/components/ToasterWrapper';
import { LabelButtonDownload } from '@/react/components/TableActionButtons'
import { LabelButton } from '@/react/components/TableActionButtons'
import Modal from '@/react/libraries/Modal';
const { toast } = ToasterWrapper
import gsap from 'gsap'

import Swal from 'sweetalert2';

// constants
import { API_URL, BASE_URL } from '@/react/pages/qc/base/{utils}/constants';

import { ButtonTabLayout, ButtonTab } from '@/react/libraries/ButtonTabs';
import Pagination from '../../components/Pagination';

const Page = ({ payload }) => {
	const { msid } = payload

	const [activeTab, setActiveTab] = useState(0)


	const [changeNotifData, setChangeNotifData] = useState([])
	const [changeNotifPage, setChangeNotifPage] = useState(1)
	const [changeNotifPageLength, setChangeNotifPageLength] = useState(10)
	const [changeNotifOrder, setChangeNotifOrder] = useState('chronological')

	const [completedChangeData, setCompletedChangeData] = useState([])
	const [completedChangePage, setCompletedChangePage] = useState(1)
	const [completedChangePageLength, setCompletedChangePageLength] = useState(10)
	const [completedChangeOrder, setCompletedChangeOrder] = useState('')
	const [preApprovals, setPreApprovals] = useState({
		retention_period_no_gs: false,
		retention_period_gs: false,
		change_in_law_no_gs: false,
		change_in_law_gs: false,
		from: false,
		articles: false,
	});
	const [disableApply, setdisableApply] = useState(true);
	const modalRef = useRef();

	const [loading, setLoading] = useState(false)

	const [summary, setSummary] = useState({
		change_from: '',
		total_changes: 0,
		retention: 0,
		from: 0,
		sg: 0,
	})

	const containerRef = useRef(null);

	// /dashboard/datatable/my-schedule/185/change-notification?page=1&order=chronological&data_class=%5B%22General+records%22%5D&data_type=%5B%22Data+breach+register+and+data+breach+notification+records%22%5D&jurisdiction_country=%5B%227%22,%22213%22%5D&jurisdiction_state=%5B%2228%22%5D&per_page=10
	const initDropdown = async () => {
		const url = `${API_URL}list/ms-notification/${msid}`
		const jurisdictionDropdown = new MultiLayerDropdown(document.querySelector('#jurisdictions'), {
			searchPlaceholder: 'Search jurisdictions',
			levels: ['Country', 'State'],
			keys: ['jurisdiction_country', 'jurisdiction_state'],
		})

		const dataClassDropdown = new MultiLayerDropdown(document.querySelector('#datatypes'), {
			searchPlaceholder: 'Search data classes & types',
			levels: ['Data Class', 'Data Type'],
			keys: ['data_class', 'data_type'],
		})

		const gsImpact = new MultiLayerDropdown(document.querySelector('#gs'), {
			searchPlaceholder: 'Search golden standard impact',
			levels: ['Impact Type'],
			keys: ['gs_impact'],
		})

		gsImpact.initializeData([
			{
				name: 'Golden Standard impact',
				value: true,
				active: true
			},
			{
				name: 'No Golden Standard impact',
				value: false,
				active: true
			}
		])

		fetch(`${url}/jurisdictions`, {
			method: 'GET',
			headers: HEADER_OBJ,
		}).then(res => res.json()).then(res => {
			jurisdictionDropdown.initializeData(res)
		})

		fetch(`${url}/data-class-data-types`, {
			headers: HEADER_OBJ,
			method: 'GET',
		}).then(res => res.json()).then(res => {
			dataClassDropdown.initializeData(res)
		})

	}

	const fetchChangeNotifData = async () => {
		const url = `${API_URL}datatable/my-schedule/${msid}`
		setLoading(true)
		// axios
		let data = await axios.get(`${url}/change-notification?page=${changeNotifPage}&order=${changeNotifOrder}&per_page=${changeNotifPageLength}&${parseSearchData()}`, {
			headers: HEADER_OBJ,
		})

		data = data.data
		if(data.pre_approval){
			setPreApprovals(data.pre_approval)
		}
		setChangeNotifData(data)
		setSummary(data.summary)
		setLoading(false)
	}

	const fetchCompletedChanges = async () => {
		const url = `${API_URL}datatable/my-schedule/${msid}`
		setLoading(true)
		// axios
		let data = await axios.get(`${url}/change-review?page=${completedChangePage}&changes=${completedChangeOrder}&per_page=${completedChangePageLength}&${parseSearchData()}`, {
			headers: HEADER_OBJ,
		})

		data = data.data
		setCompletedChangeData(data)
		setLoading(false)
	}

    const downloadExcel = async () => {
        setLoading(true)
        try {
            let url = `${BASE_URL}export-ms-notification/${msid}`
            let fileName = `notification-${msid}-`
            if(activeTab === 0) {
                url += `?order=${changeNotifOrder}&${parseSearchData()}`
                fileName += `${changeNotifOrder}.xlsx`
            } else {
                url +=`/change-review?changes=${completedChangeOrder}&${parseSearchData()}`
                fileName += `completed.xlsx`
            }
            const response = await axios.get(`${url}`, {
                responseType: 'blob',
                headers: HEADER_OBJ,
            });
            const blob = new Blob([response.data]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading the Excel file:', error);
        } finally {
            setLoading(false)
        }
    };

	const parseSearchData = () => {
		// get jurisdiction and data type
		const jurisdictionDropdown = document.querySelector('#jurisdictions').__multi_layer_instance
		const dataClassDropdown = document.querySelector('#datatypes').__multi_layer_instance
		const gsDropdown = document.querySelector('#gs').__multi_layer_instance

		const selectedJd = jurisdictionDropdown.getValues()
		const selectedDc = dataClassDropdown.getValues()
		const selectedGs = gsDropdown.getValues()

		// make a query string
		let str = ''
		Object.entries(selectedJd).forEach(([key, value]) => {
			str += `${key}=${JSON.stringify(value)}&`
		})

		Object.entries(selectedDc).forEach(([key, value]) => {
			str += `${key}=${JSON.stringify(value)}&`
		})

		Object.entries(selectedGs).forEach(([key, value]) => {
			str += `${key}=${JSON.stringify(...value)}&`
		})

		return str
	}

	useEffect(() => {
		initDropdown()
	}, [])

	useEffect(() => {
		const jurisdictionDropdown = document.querySelector('#jurisdictions').__multi_layer_instance
		const dataClassDropdown = document.querySelector('#datatypes').__multi_layer_instance

		jurisdictionDropdown.clear()
		dataClassDropdown.clear()
	}, [activeTab])

	useEffect(() => {
		if (activeTab === 0)
			fetchChangeNotifData()
	}, [changeNotifPage, changeNotifOrder, changeNotifPageLength, activeTab])

	useEffect(() => {
		if (activeTab === 1)
			fetchCompletedChanges()
	}, [completedChangePage, completedChangeOrder, completedChangePageLength, activeTab])

	const handleInputChange = (e) => {
		const { name, checked } = e.target;
		setPreApprovals((prev) => ({
			...prev,
			[name]: checked,
		}));
	};

	useEffect(()=>{
		const isChecked = Object.values(preApprovals).some(val => val);
		if(isChecked){
			setdisableApply(!isChecked);
		}else{
			setdisableApply(true)
		}
	}, [preApprovals]);

	const handleApply = async () => {
		const link = `${BASE_URL}my-schedule/${msid}/pre-approve-changes`;
		const url = window.replaceURLString(link)

		Swal.fire({
			title: `Do you want to pre-approve this changes?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: `Confirm`,
		}).then((result) => {
			if (result.isConfirmed) {
				axios.post(url,preApprovals,
				 {
					headers: HEADER_OBJ,
				}).then(res => {
					toast.success(`${res.data.message}`);
				}).catch(err => {
					toast.error('An error occurred')
				}).finally(() => {
					modalRef.current?.closeModal();
				})
			}
		})
	};

	return (
		<>
			<div className='flex flex-col gap-4'>
				<div className='flex items-start'>
					<div className='control-center grow mr-10 max-w-[1000px]'>
						<div id='jurisdictions' className='w-full'>
						</div>
						<div id='datatypes' className='w-full'>
						</div>
						<div id='gs' data-multi-select="false" className='w-full'>
						</div>
						<button className="btn btn-icon-wide" onClick={() => {
							if (activeTab === 0) fetchChangeNotifData()
							if (activeTab === 1) fetchCompletedChanges()
						}}>
							<span className="material-symbols-rounded">search</span>
						</button>
						<button className="btn btn-icon-wide" type="button">
							<span className="material-symbols-rounded">cached</span>
						</button>
					</div>
					<div className='ml-auto p-2 border-thin border-grey rounded-primary flex flex-col text-xxs'>
						<p>- Changes since {summary.change_from}</p>
						<p>- Total: {summary.total_changes} changes</p>
						<p>- Retention period: {summary.retention} changes</p>
						<p>- From: {summary.from} changes</p>
						<p>- Suggestions: {summary.sg} suggestions</p>
					</div>
				</div>

				<div className='flex'>
					<ButtonTabLayout containerRef={containerRef} onChange={(index) => setActiveTab(index)}>
						<ButtonTab
							renderComponent={<ChangeNotifications
								data={changeNotifData}
								setPage={setChangeNotifPage}
								setLength={setChangeNotifPageLength}
								page={changeNotifPage}
								length={changeNotifPageLength}
								fetchChangeNotifData={fetchChangeNotifData} />}>
							<p>Pending Changes</p>
						</ButtonTab>
						<ButtonTab
							renderComponent={
								<CompletedChanges
									data={completedChangeData}
									setPage={setCompletedChangePage}
									setLength={setCompletedChangePageLength}
									page={completedChangePage}
									length={completedChangePageLength}
									fetchCompletedChanges={fetchCompletedChanges} />}>
							<p>Completed</p>
						</ButtonTab>
					</ButtonTabLayout>
					<div className='flex items-center gap-2 ml-auto'>
						<div className='flex items-center gap-2'>
							<p>Sort by:</p>
							{
								activeTab === 0 && <select name="order" className='font-bold' id="order" onChange={(e) => setChangeNotifOrder(e.target.value)} value={changeNotifOrder}>
									<option value="chronological" >Date</option>
									<option value="jurisdiction">Jurisdiction</option>
									<option value="data-type">Data Type</option>
								</select>
							}

							{
								activeTab === 1 && <select name="order" className='font-bold' id="order" onChange={(e) => setCompletedChangeOrder(e.target.value)} value={completedChangeOrder}>
									<option value="">All</option>
									<option value="1">Accepted</option>
									<option value="2">Declined</option>
								</select>
							}

						</div>
						<div className='w-0.5 h-1/2 bg-grey-50'>

						</div>
						<div className="table-controls mb-0">
							<LabelButton iconClass="material-symbols-rounded" onClick={modalRef.current?.openModal} iconText='check_circle' content="Pre approvals"/>
							<LabelButtonDownload onClick={downloadExcel} />
						</div>
					</div>
				</div>

				<div className={`transition-all ${loading ? 'disabled' : ''}`} ref={containerRef}>
				</div>
			</div>
			<Modal ref={modalRef} className="modal__content-wrapper p-2">
				<div>
					<div className="modal__content-wrapper-header !pb-0">
						<h2>Pre-approve changes</h2>
					</div>
					<p>Want fewer interruptions? Pre-approve certain changes and they’ll update your schedule automatically.</p>
				</div>
				<div className="modal__content-wrapper-body [&>label]:flex [&>label]:items-center [&>label]:gap-2">
					<p className="text-label font-medium">Pre-approve changes to:</p>
					<label>
			           	<input name="retention_period_no_gs" type="checkbox" 
						checked={preApprovals.retention_period_no_gs}
    					onChange={handleInputChange}
			           /> Retention period (No Golden Standard impact)
			       	</label>
			       	<label>
			           	<input name="retention_period_gs" type="checkbox" 
			           	checked={preApprovals.retention_period_gs}
    					onChange={handleInputChange}
			           /> Retention period (Golden Standard impact)
			       	</label>
			       	<label>
			           	<input name="change_in_law_no_gs" type="checkbox" 
			           	checked={preApprovals.change_in_law_no_gs}
    					onChange={handleInputChange}
			           	/> Suggested change in law (No Golden Standard impact)
			       	</label>
			       	<label>
			           	<input name="change_in_law_gs" type="checkbox" 
			           	checked={preApprovals.change_in_law_gs}
    					onChange={handleInputChange}
			           	/> Suggested change in law (Golden Standard impact)
			       	</label>
			       	<label>
			           	<input name="from" type="checkbox" 
			           	checked={preApprovals.from}
    					onChange={handleInputChange}
			           	/> From
			       	</label><label>
			           	<input name="articles" type="checkbox" 
			           	checked={preApprovals.articles}
    					onChange={handleInputChange}
			           	/> Articles (Suggestions)
			       	</label>
				</div>
				<div className="modal__content-wrapper-footer !gap-2">
					<button className='btn btn-outline-primary' onClick={modalRef.current?.closeModal}>Cancel</button>
					<button className="btn" disabled={disableApply} onClick={handleApply}>Apply</button>
				</div>
			</Modal>
		</>
	);
}

const CompletedChanges = ({ data, fetchCompletedChanges, length, setLength, page, setPage }) => {
	if (!data.rows || data.rows.length === 0) return <>
		<div className='flex flex-col gap-4 items-center justify-center'>
			<p className='text-secondaryHead text-grey-text font-medium'>No changes found</p>
		</div>
	</>

	return (<>
		<CompletedChangesTable data={data} fetchCompletedChanges={fetchCompletedChanges} />
		<Pagination totalCount={data.total_count} length={length} currentPage={page} setLength={setLength} setCurrentPage={setPage} />
	</>
	)
}

const CompletedChangesTable = ({ data, fetchCompletedChanges }) => {
	const handleCompletedChange = (actionLink) => {
		const link = window.replaceURLString(actionLink)
		Swal.fire({
			title: `Do you want to revert this change?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: `Revert`,
		}).then((result) => {
			if (result.isConfirmed) {
				axios.post(link, {
					headers: {
						'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
						'Content-Type': 'application/json'
					},
				}).then(res => {
					toast.success(`Reverted successfully`)
				}).catch(err => {
					toast.error('An error occurred')
				}).finally(() => {
					// remove the row
					fetchCompletedChanges()
				})
			}
		})
	}


	return <div className='fk-table-alt flex flex-col gap-4'>
		<table>
			<thead>
				<tr>
					<th>Ref</th>
					<th>Data class</th>
					<th>Data type</th>
					<th>Jurisdiction</th>
					<th>Changes</th>
					<th className='!text-center'>Approved by</th>
					<th>Approval Date</th>
					<th>Type</th>
					{
						data.can_edit &&
						<th className='!text-center'>Action</th>
					}
				</tr>
			</thead>
			<tbody>
				{
					data.rows.map((row, index) => {
						return <tr key={index}>
							<Cell value={row.ref} />
							<Cell value={row.data_class} />
							<Cell value={row.data_type} />
							<Cell value={row.jurisdiction} />
							<Cell className={'whitespace-nowrap'} value={row.changes} />
							{

								row.user === null ?
									<Cell className={'!text-center'} value={row.user} /> :

									<td className={'!text-center'}>

										<div className='flex flex-col items-center justify-center gap-2'>
											{
												row.user.pic && <>
													<div data-tippy-options={
														JSON.stringify({
															arrow: true,
															interactive: true,
															placement: "right-start",
															theme: "retention-schedule gs-badge-tooltip",
															offset: [0, 20],
															content: `<div class='flex flex-col gap-1 p-1'>
															<div>
																<p class="font-bold">${row.user.full_name}</p>
																<p class="font-medium text-xxs -mt-0.5 text-grey-text">${row.user.role}</p>
															</div>
															<hr>
															<div class="flex items-center gap-1"><span class="font-MaterialIcons text-lg text-primary mt-0.5">email</span><p class="font-bold text-xxs">${row.user.email}</p></div>
														</div>`
														})
													}>
														<img src={replaceURLString(row.user.pic)} className='h-12 w-12 rounded-full object-cover' />
													</div>
													<p>{row.user.first_name}</p>
												</>
											}

											{
												!row.user.pic &&
												<div data-tippy-options={
													JSON.stringify({
														arrow: true,
														interactive: true,
														placement: "right-start",
														offset: [-10, 20],
														theme: "retention-schedule gs-badge-tooltip",
														content: `<div class='flex flex-col gap-1 p-1'>
															<div>
																<p class="font-bold">${row.user.full_name}</p>
																<p class="font-medium text-xxs -mt-0.5 text-grey-text">${row.user.role}</p>
															</div>
															<hr>
															<div class="flex items-center gap-1"><span class="font-MaterialIcons text-lg text-primary mt-0.5">email</span><p class="font-bold text-xxs">${row.user.email}</p></div>
														</div>` 
													})
												}>
													<p>{row.user.first_name}</p>
												</div>
											}
										</div>
									</td>
							}
							<Cell value={row.date} />
							<Cell value={row.type} />
							{
								data.can_edit &&
								<td>
									<div className="table-action-buttons">
										<a className="btn btn-round btn-secondary" onClick={() => handleCompletedChange(row.action)}><span className="font-MaterialIcons text-xl">cached</span></a>
									</div>
								</td>
							}
						</tr>
					})
				}
			</tbody>
		</table>
	</div>
}

const ChangeNotifications = ({ data, setPage, setLength, page, length, fetchChangeNotifData }) => {
	if (!data.rows || data.rows.length === 0) return <>
		<div className='flex flex-col gap-4 items-center justify-center'>
			<p className='text-secondaryHead text-grey-text font-medium'>No changes found</p>
		</div>
	</>

	return (<div className='flex flex-col gap-10 border-thin rounded-primary p-6'>
		{data.rows && data.rows.map((row, index) =>
			<ChangeNotification data={row} edit={data.can_edit} key={index} fetchChangeNotifData={fetchChangeNotifData} />
		)}


		<div className='flex'>
			{/* per page */}
			<div className='flex items-center gap-2'>
				<p className='font-medium py-0 text-sm'>
					Show Results
				</p>
				<select className='rounded-primary border-normal border-grey p-1 pl-2 pr-11' defaultValue={length} onChange={(e) => {
					setLength(Number(e.target.value))
				}}>
					{
						[10, 25, 50, 100].map((option, index) => <option key={index} value={option}>{option}</option>)
					}
				</select>
				<p className='font-medium py-0 text-sm'>
					out of {data.total_count} results
				</p>
			</div>

			{/* pagination */}
			{
				data.total_page > 1 &&
				<div className='ml-auto'>
					<PageTracker totalPage={data.total_page} setPage={setPage} currentPage={page} />
				</div>
			}
		</div>
	</div>
	)
}

export const PageTracker = ({ totalPage, setPage, currentPage }) => {
	const getVisiblePages = () => {
		const pages = [];
		const maxVisiblePages = 7; // Total visible buttons (including ellipses)

		if (totalPage <= maxVisiblePages) {
			// If the total number of pages is small, show all
			for (let i = 1; i <= totalPage; i++) pages.push(i);
		} else {
			if (currentPage <= 4) {
				// Show first few pages
				pages.push(1, 2, 3, 4, 5, '...', totalPage);
			} else if (currentPage >= totalPage - 3) {
				// Show last few pages
				pages.push(1, '...', totalPage - 4, totalPage - 3, totalPage - 2, totalPage - 1, totalPage);
			} else {
				// Show middle pages
				pages.push(1, '...', currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2, '...', totalPage);
			}
		}
		return pages;
	};

	const handlePageChange = (page) => {
		if (page < 1 || page > totalPage || page === currentPage) return;
		setPage(page);
	};

	const visiblePages = getVisiblePages();

	return (
		<div className="flex items-center">
			{/* First */}
			<PaginationIcon onClick={() => handlePageChange(1)} icon="first_page" />

			{/* Previous */}
			<PaginationIcon onClick={() => handlePageChange(currentPage - 1)} icon="chevron_left" />

			{/* Page Buttons */}
			<div className="mx-1">
				{visiblePages.map((page, index) =>
					page === '...' ? (
						<span key={index} className="px-3 text-grey-text">
							...
						</span>
					) : (
						<button
							key={index}
							onClick={() => handlePageChange(page)}
							className={`btn px-3 transition-all hover:scale-125 animate-none ${currentPage === page ? 'btn-primary' : 'hover:text-primary bg-transparent text-grey-text'
								}`}
						>
							{page}
						</button>
					)
				)}
			</div>

			{/* Next */}
			<PaginationIcon onClick={() => handlePageChange(currentPage + 1)} icon="chevron_right" />

			{/* Last */}
			<PaginationIcon onClick={() => handlePageChange(totalPage)} icon="last_page" />
		</div>
	);
};

const PaginationIcon = ({ icon, onClick }) => {
	return <button onClick={onClick} className={`flex items-center justify-center p-0 bg-transparent text-grey-text transition-all hover:text-primary hover:scale-125`} >
		<span className="material-symbols-rounded text-2xl">{icon}</span>
	</button>
}


const ChangeNotification = ({ data, edit, fetchChangeNotifData }) => {
	const heading = data.main_heading
	const rows = data.child_data

	return <div className='flex flex-col gap-4'>
		<p className='text-secondaryHead text-grey-text font-medium max-w-[60%]'>{heading}</p>
		{
			rows.map((row, index) =>
				<Row row={row} edit={edit} index={index} key={index} last={index === rows.length - 1} fetchChangeNotifData={fetchChangeNotifData} />
			)
		}
	</div>
}

// jsdoc
/**
 * @param {object} props
 * @param {object} props.row
 * @param {number} props.index
 */
const Row = ({ row, edit, index, last, fetchChangeNotifData }) => {
	return <>
		<div className='flex gap-6'>
			<div className='flex flex-col items-center relative'>
				{/* timeline */}

				<div className='bg-white border-normal border-primary rounded-full h-8 p-1 aspect-square text-primary font-bold text-secondaryHead flex items-center justify-center'>
					{index + 1}
				</div>
				<div className='h-full bg-grey-50 w-1'>
				</div>
				{
					last ? null : <div className='bg-grey-50 w-1 absolute -bottom-4 h-4'>
					</div>
				}

			</div>
			<div className='flex flex-col gap-4 grow'>
				<div className='flex flex-col gap-1 max-w-[700px]'>
					{/* info */}

					<details>
						<summary className='flex-row-reverse relative w-full border-b-0 pb-0 items-start justify-end
						[&:before]:-mt-1.5'>
							<div>
								<p className='font-bold text-article'>{row.title}</p>
								<p>{row.ref}</p>
							</div>
						</summary>
						<p className='pt-0'>{row.data_type_example}</p>
					</details>
					<p className='text-grey-text font-medium'>{row.sub_heading}</p>
				</div>
				<div className='self-end flex gap-4 items-center'>
					<p className='text-secondaryHead text-primary font-bold'>{row.change_field}</p> <div className='h-1/2 w-0.5 bg-grey'></div> <GsImpact gs={row.gs}></GsImpact>
				</div>
				{/* changes */}
				<div className='fk-table-alt-change-notif'>
					<Table row={row} edit={edit} fetchChangeNotifData={fetchChangeNotifData} />
				</div>
				<CurrentGS gs={row.gs} />
			</div>
		</div>
	</>

}

const Table = ({ edit, row, fetchChangeNotifData }) => {
	const values = [row.new_value, row.old_value]
	const handleNotificationChange = (actionLink, accept) => {
		const action = accept ? 'accept' : 'refuse'
		const link = window.replaceURLString(actionLink)

		Swal.fire({
			title: `Do you want to ${action} this change?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: `${action.charAt(0).toUpperCase() + action.slice(1)}`,
		}).then((result) => {
			if (result.isConfirmed) {
				// console.log(actionLink)
				// toast.success(`${action.charAt(0).toUpperCase() + action.slice(1)}ed successfully`)
				axios.post(link, {
					headers: {
						'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
						'Content-Type': 'application/json'
					},
				}).then(res => {
					toast.success(`${action.charAt(0).toUpperCase() + action.slice(1)}ed successfully`)
				}).catch(err => {
					toast.error('An error occurred')
				}).finally(() => {
					// remove the row
					fetchChangeNotifData()
				})
			}
		})
	}

	const [checkboxes, setCheckboxes] = useState({
		other_jurisdiction: false,
		other_data_type: false,
	});

	const [disableBtn, setDisableBtn] = useState(true);

	const [type, setType] = useState(1)

	const handleCheckboxChange = (key) => {
	  	setCheckboxes(prev => {
	    	const updateVal = {...prev, [key]: !prev[key]}; 
	    	const anyChecked = Object.values(updateVal).some(val => val);
	    	setDisableBtn(!anyChecked)
	    	return updateVal;
	  	});
	};

	const handleTypeChange = (value) => {
	  	setType(value);
	};

	const handleAppliedClick =()=>{
		let params = [`type=${type}`];

		params.push(
		  	...Object.entries(checkboxes)
		    .filter(([_, value]) => value)
		    .map(([key, value]) => `${key}=${value}`)
		);

		let submitType;
		if(type === 1)
			submitType = "accept"
		else
			submitType = "decline"

		const queryString = params.join("&");
		const fullUrl = `${row.same_changes}&${queryString}`;
		const url = window.replaceURLString(fullUrl);

		Swal.fire({
			title: `Do you want to ${submitType} same changes?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: `${submitType.charAt(0).toUpperCase() + submitType.slice(1)} Same Changes`,
		}).then((result) => {
			if (result.isConfirmed) {
				axios.post(url, {
					headers: {
						'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
						'Content-Type': 'application/json'
					},
				}).then(res => {
					toast.success(`${submitType.charAt(0).toUpperCase() + submitType.slice(1)}${type==1?"ed":"d"} successfully`);
					//reset every local state
					setDisableBtn(true);
					setCheckboxes({
						other_jurisdiction: false,
						other_data_type: false,
					});
					setType(1);
				}).catch(err => {
					toast.error('An error occurred')
				}).finally(() => {
					fetchChangeNotifData()
				})
			}
		})
	}

	return <table>
		<thead>
			<tr>
				<th className='!w-[105px]'></th>
				<th className='!min-w-[236px] !w-[236px]'>Min or Max</th>
				<th className='!w-[100px] !text-right'>Retention</th>
				<th className='!w-[100px]'>Period</th>
				<th className='!w-[30%]'>From</th>
				<th className='!w-[30%]'>Article</th>
				<th className='!w-[130px]'>FKID</th>
				{
					edit &&
					<th className='!text-center !w-[170px]'>Action</th>
				}
			</tr>
			<tr className='h-2'></tr>
		</thead>
		<tbody>
			{
				values.map((value, index) => {
					return <tr key={index}>
						<td className='font-bold !text-right whitespace-nowrap'>{index === 0 ? 'New value' : 'Old value'}</td>
						<Cell value={value.minMax} />
						<Cell value={value.retention} className={'!text-right'} />
						<Cell value={value.period} />
						<Cell value={value.from} />
						<td><a href={value.link}
							// open in new tab
						target="_blank"
						className={value.legalRef !== null ? '' : '!text-grey !pointer-events-none'}>{value.legalRef || '--'}</a></td>
						<Cell value={value.fkID} />
						{
							edit && <td>
								{
									// only the first row has the action buttons, as we are rendering 2 rows as new and old values
									index === 0 ? <div className="table-action-buttons">
										<a className="btn btn-round" onClick={() => handleNotificationChange(row.accept, true)}><span className="font-MaterialIcons font-bold text-xl">check</span></a>
										<a className="btn btn-round btn-secondary" onClick={() => handleNotificationChange(row.decline, false)}><span className="font-MaterialIcons font-bold text-xl">close</span></a>
										<CollapsableDropdown>
									      {(closeDropdown) => (
									        <div className="flex flex-col gap-2 [&>label]:flex [&>label]:gap-2 [&>label]:items-center [&>label]:ml-2.5">
									        	<h3 className="text-label text-sub2 font-medium">Same change</h3>
									        	<div className="flex gap-4 mb-1">
									        		<label className="flex gap-1.5 text-label font-medium items-center"><input name="type" type="radio" value="1" onChange={()=>handleTypeChange(1)} checked={type === 1}/> Accept</label>
									        		<label className="flex gap-1.5 text-label font-medium items-center"><input name="type" type="radio" value="2" onChange={()=>handleTypeChange(2)} checked={type === 2} /> Decline</label>
									        	</div>
										        <label>
										            <input name="other_jurisdiction" id="other_jurisdiction" type="checkbox" 
										            checked={checkboxes.other_jurisdiction}
	            									onChange={() => handleCheckboxChange("other_jurisdiction")}
										            /> For other jurisdictions
									          	</label>
									          	<label>
										            <input name="other_datatype" id="other_datatype" type="checkbox" 
										            checked={checkboxes.other_data_type}
	            									onChange={() => handleCheckboxChange("other_data_type")}
										            /> For other data types
									          	</label>
									          	<div className="flex items-center gap-2 justify-end mt-2">
										          	<button className='btn btn-outline-primary' onClick={closeDropdown}>Cancel</button>
													<button className="btn" disabled={disableBtn} onClick={handleAppliedClick}>Apply</button>
									          	</div>
									        </div>
									      )}
									    </CollapsableDropdown>
									</div> : null
								}
							</td>
						}

					</tr>
				})
			}
		</tbody>
	</table>
}

const CollapsableDropdown = ({children}) =>{
	const [open, setOpen] = useState(false)
	const dropdownRef = useRef(null)
	const menuRef = useRef(null)

	useEffect(()=>{
		const handleClickOutside = (e)=>{
			if(dropdownRef.current && !dropdownRef.current.contains(e.target)){
				setOpen(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return ()=> document.removeEventListener('mousedown', handleClickOutside)
	}, [])

	useEffect(() => {
		if (open && menuRef.current) {
			gsap.fromTo(
		      	menuRef.current,
		      	{ y: -10, opacity: 0, scale: 0.2, transformOrigin: "top right" },
		      	{
			        y: 0,
			        opacity: 1,
			        duration: 0.3,
			        scale: 1,
			        ease: 'power2.out',
		      	}
		    );
		}
	}, [open]);

	return (
	    <div className="relative inline-block" ref={dropdownRef}>
	      	<button
	        	onClick={() => setOpen(!open)}
	        	className="text-grey-text border-thin rounded-full w-8 h-8 hover:text-primary hover:border-primary transition-all text-sub2 leading-5 bg-transparent"
	        	aria-label="Options"><span className="material-symbols-rounded">more_vert</span></button>

	      	{open && (
	        	<div ref={menuRef} className="absolute -right-2 mt-4 !w-72 bg-white shadow-primary border-normal rounded-primary p-4 z-50 
	        	before:w-3 before:h-3 before:bg-white before:absolute before:border-l-normal before:border-t-normal before:top-[-7px] before:right-4 before:rotate-45">
	          		{typeof children === 'function' ? children(() => setOpen(false)) : children}
	        	</div>
	      	)}
	    </div>
    );
}

const GsImpact = ({ gs }) => {
	const isActive = gs !== null
	return <div className={`flex items-center text-label p-2 px-4 rounded-primary font-bold gap-2 border-normal
		${isActive ? 'border-secondary text-secondary bg-secondary bg-opacity-5' : 'text-grey-text border-grey-50 disabled'}`
	}>
		<span className="material-symbols-rounded text-xl font-thin">warning</span> {!isActive && 'NO'} Golden Standard Impact
	</div>
}

const CurrentGS = ({ gs }) => {
	const isActive = gs !== null;
	if (!isActive) return null;

	const { current, new: newValue } = gs;

	return <>
		<div className='self-end flex gap-4 items-center'>
			<p className='text-secondaryHead text-grey-text font-bold'>Current Golden standard: {current}</p>
			<div className='h-1/2 w-0.5 bg-grey'></div>
			<div className={`flex items-center text-label p-2 px-4 rounded-primary font-bold gap-2 border-normal border-primary text-primary bg-primary bg-opacity-5`
			}>
				New Golden Standard: {newValue}
			</div>
		</div>
	</>
}

const Cell = ({ className, value }) => {
	return <td className={`${className ?? ''} ${value !== null ? '' : '!text-grey-text !pointer-events-none'}`}>{value ?? '--'}</td>
}

function initPage(selector, payload) {
	createRoot(document.querySelector(selector)).render(
		<Page payload={payload} />
	);
}

export default initPage;
